/**
 * Viewer header component
 *
 * @version
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.56.0 OAUI-596 Migrate Large Model Viewer into Angular
 * 4.56.0 OAUI-614 Migrate LMV navigation bar into angular
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2023 Build Centrix
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-viewer-header-component',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ViewerHeaderComponent {
  // Order String Inputs
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() orderIndex?: string;
  // Order Boolean Inputs
  @Input() showHeader?: boolean = true;

  constructor(public router: Router) {}

  /**
   * Navigate to manage order
   *
   * @since 4.63.0
   */
  navigateToManageOrder(orderIndex: string): void {
    // Set the current order
    this.router.navigate(['orders', 'manage', orderIndex]);
  }
}
